import React from 'react'
import {DatePicker, Form, Input, Select} from "antd";
import config from "../../config";
import moment from "moment";

const { Option } = Select

const TotalProfitFilter = () => {

    const month = 30 * ( 24 * 60 * 60 * 1000 )
    const today = new Date()

    return(
        <React.Fragment>
            <Form.Item
                name={'startDate'}
                label={'Başlangıç Tarihi'}
                initialValue={moment(new Date(today - month))}
                rules={[
                    {required: true, message: 'Bu alan zorunludur'}
                ]}
            >
                <DatePicker format={'DD/MM/YYYY'} />
            </Form.Item>
            <Form.Item
                name={'endDate'}
                label={'Bitiş Tarihi'}
                initialValue={moment(new Date())}
                rules={[
                    {required: true, message: 'Bu alan zorunludur'}
                ]}
            >
                <DatePicker format={'DD/MM/YYYY'} />
            </Form.Item>
            <Form.Item
                name={'brandCurrency'}
                label={'Marka Para Birimi'}
                initialValue={''}
            >
                <Select>
                    {
                        config.currencyOptions.map(item => <Option key={item} value={item}>{item}</Option>)
                    }
                </Select>
            </Form.Item>
            <Form.Item
                name={'brandName'}
                label={'Marka Adı'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={'customerCurrency'}
                label={'Müşteri Para Birimi'}
                initialValue={''}
            >
                <Select>
                    {
                        config.currencyOptions.map(item => <Option key={item} value={item}>{item}</Option>)
                    }
                </Select>
            </Form.Item>
            <Form.Item
                name={'customerName'}
                label={'Müşteri Adı'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={'supplierCurrency'}
                label={'Tedarikçi Para Birimi'}
                initialValue={''}
            >
                <Select>
                    {
                        config.currencyOptions.map(item => <Option key={item} value={item}>{item}</Option>)
                    }
                </Select>
            </Form.Item>
            <Form.Item
                name={'supplierName'}
                label={'Tedarikçi Adı'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={'createdBy'}
                label={'Oluşturan'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
        </React.Fragment>
    )
}
export default TotalProfitFilter